import axios from "axios";
import { baseUrl, portal } from "../App";
import { logEvent } from "../helper/gaEvent";

export const fetchSubscriptionUrlByEventId = async (token, eventId) => {
  const searchParams = new URLSearchParams(window.location.search);
  const paramsObject = Object.fromEntries(searchParams);

  const config = {
    headers: { Authorization: `Token ${token}` },
  };
  let service_type = "Daily";
  let currency = "BDT";
  let price = 30;
  if(eventId === 34) {
    service_type = "Daily";
  }else if(eventId === 149){
    service_type = "BCS";
  }else if(eventId === 75){
    service_type = "Sports";
  }else{
    service_type = "Tournament";
    price = 40;
  }

  const res = await axios
    .post(
      `${baseUrl}/subscription/create/`,
      { portal: portal, qcid: sessionStorage.getItem("cid"), "service_type": service_type, ...paramsObject },
      config
    )
  localStorage.setItem("subscription_checkout", JSON.stringify({ serviceType: service_type, time: Date.now() }));
  logEvent("begin_checkout",{
    service_type: service_type,
    currency: "BDT",
    price: price,
  });
  return res.data;
}